/* eslint-disable import/no-extraneous-dependencies */

import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './skeletonLayer.scss'

const SkeletonLayer = (props) => {
  const { active, loading, width, height } = props

  const skeletonLayerStyles = {}

  if (width) skeletonLayerStyles.width = `${width}px`

  if (height) skeletonLayerStyles.height = `${height}px`

  const skeletonLayerClass = classNames(styles.skeletonLayer, {
    [styles.active]: loading || active
  })

  return (
    <div className={skeletonLayerClass}>
      <progress className={styles.bar} style={skeletonLayerStyles} />
    </div>
  )
}

SkeletonLayer.defaultProps = {
  active: false,
  loading: false,
  width: 60,
  height: 14
}

const { bool, number } = PropTypes

SkeletonLayer.propTypes = {
  active: bool,
  loading: bool,
  width: number,
  height: number
}

export default SkeletonLayer
